import React from "react";
import TargetTypeNameField from "../TargetTypeNameField";

function DeviceTypeNameField({ deviceType, setDeviceType }) {
    const onChange = (value) => setDeviceType({ ...deviceType, name: value });

    return (
        <TargetTypeNameField
            value={deviceType.name}
            onValueChange={onChange}
            label="Name"
        />
    );
}

export default DeviceTypeNameField;
